'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_AdHoc$package$Cat$1(name, kind, color) {
  this.so = null;
  this.sn = false;
  this.sm = null;
  this.so = name;
  this.sn = kind;
  this.sm = color;
}
export { $c_Lsamples_AdHoc$package$Cat$1 as $c_Lsamples_AdHoc$package$Cat$1 };
$p = $c_Lsamples_AdHoc$package$Cat$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_AdHoc$package$Cat$1;
/** @constructor */
function $h_Lsamples_AdHoc$package$Cat$1() {
}
export { $h_Lsamples_AdHoc$package$Cat$1 as $h_Lsamples_AdHoc$package$Cat$1 };
$h_Lsamples_AdHoc$package$Cat$1.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, 67510);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.so));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, (this.sn ? 1231 : 1237));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sm));
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 3);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsamples_AdHoc$package$Cat$1)) {
    if (((this.sn === x$0.sn) && (this.so === x$0.so))) {
      var x = this.sm;
      var x$2 = x$0.sm;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 3;
});
$p.o = (function() {
  return "Cat";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.so;
      break;
    }
    case 1: {
      return this.sn;
      break;
    }
    case 2: {
      return this.sm;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lsamples_AdHoc$package$Cat$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e8)));
}
export { $isArrayOf_Lsamples_AdHoc$package$Cat$1 as $isArrayOf_Lsamples_AdHoc$package$Cat$1 };
var $d_Lsamples_AdHoc$package$Cat$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_AdHoc$package$Cat$1, "samples.AdHoc$package$Cat$1", ({
  e8: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_AdHoc$package$Cat$1 as $d_Lsamples_AdHoc$package$Cat$1 };
